import { toast } from 'react-toastify';
import appApi from '../../../../../api/app-api';
import globalProgramStore from '../../../../../stores/program-store';
import {
  ApiErrorCodes,
  displayErrorText,
} from '../../../../../api/errors/api-error-codes';

export const updateCourseYearOperation = async (
  branchId: number | undefined,
  programId: number | undefined,
  courseId: number | undefined,
  programYear: number,
  setCourseLoading: (courseId: number | null) => any,
  handleExpandedRows: () => any,
) => {
  try {
    if (!branchId || !programId || !courseId) {
      toast.warn(
        'לא ניתן לאתר את מזהה התוכנית ו/או הקורס, יש לנסות שוב בעוד מספר רגעים',
      );
      return;
    }

    setCourseLoading(courseId);

    const res = await appApi.updateProgramCourseYear(
      branchId,
      programId,
      courseId,
      programYear,
    );
    if (res.data.ok) {
      handleExpandedRows();

      globalProgramStore.updateProgramDetails(programId, res.data.body);
    } else if (res.data.errCode === ApiErrorCodes.COURSE_IS_NOT_EMPTY) {
      toast.warn(displayErrorText(res.data.errCode));
    }

    setCourseLoading(null);
  } catch (e) {
    setCourseLoading(null);
    toast.error('משהו קרה, נסה שוב בעוד מספר רגעים...');
  }
};
